import React from 'react';
import { arrayOf, number, shape, string } from 'prop-types';
import map from 'lodash/map';
import cx from 'classnames';
import { FormattedHTMLMessage } from 'react-intl';
import QuestionText from '../reusable/QuestionText';
import addExtraZero from '../helpers/addExtraZero';
import InputWithGroup from '../reusable/InputWithGroup';
import { fieldNames } from '../const';

const UnsureLenderQuestion = ({ otherLendersFunds }) => {
  const lendersCount = otherLendersFunds.length;
  const lenderPluralOrSingular = lendersCount > 1 ? 'lenders' : 'lender';

  return (
    <div className="followup__question-container">
      <QuestionText
        textId="followup.question.unsureLender"
        values={{ lendersCount, lenderPluralOrSingular }}
      />

      {
        map(otherLendersFunds, ({ lenderName, creditedAmount }, index) => (
          <div key={lenderName}>
            <div
              className={cx('followup__question-header', {
                'followup__question-header--marginTop': index > 0,
              })}
            >
              <FormattedHTMLMessage
                id="followup.question.unsureLender.lenderAmount"
                values={{ lenderName, amount: addExtraZero(creditedAmount) }}
              />
            </div>

            <InputWithGroup
              groupName={`${fieldNames.unsureLenderFrequency}-${lenderName.replaceAll(/[^A-Z0-9]+/ig, '')}`}
              inputName={`${fieldNames.unsureLenderAmount}-${lenderName.replaceAll(/[^A-Z0-9]+/ig, '')}`}
              errorValues={{ min: 0, max: 10000 }}
            />
          </div>
        ))
      }
    </div>
  );
};

UnsureLenderQuestion.propTypes = {
  otherLendersFunds: arrayOf(shape({
    lenderName: string,
    creditedAmount: number,
  })),
};

export default UnsureLenderQuestion;
